var _path, _rect, _circle, _g, _rect2, _circle2, _g2, _rect3, _circle3, _g3, _rect4, _path2, _rect5, _path3, _rect6, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceHobbyDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 138,
    viewBox: "0 0 294 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.5 122.5L228.5 135.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9757)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 31,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11322_9757",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 31,
    width: 64,
    height: 64
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 63,
    r: 32,
    fill: "#CCCCCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11322_9757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4579 112.026C28.0026 123.481 9.42973 123.481 -2.02565 112.026C-13.481 100.57 -13.481 81.9975 -2.02565 70.5421C9.42973 59.0868 28.0026 59.0868 39.4579 70.5421C50.9133 81.9975 50.9133 100.57 39.4579 112.026Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0261 55.455C84.5707 66.9104 65.9979 66.9104 54.5425 55.455C43.0871 43.9996 43.0871 25.4268 54.5425 13.9714C65.9979 2.51604 84.5707 2.51604 96.0261 13.9714C107.481 25.4268 107.481 43.9996 96.0261 55.455Z",
    fill: "#F7F9ED"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9757)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 31,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11322_9757",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 31,
    width: 64,
    height: 64
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 63,
    r: 32,
    fill: "#CCCCCC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11322_9757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.458 112.026C124.003 123.481 105.43 123.481 93.9743 112.026C82.519 100.57 82.519 81.9975 93.9743 70.5421C105.43 59.0868 124.003 59.0868 135.458 70.5421C146.913 81.9975 146.913 100.57 135.458 112.026Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.026 55.455C180.571 66.9104 161.998 66.9104 150.542 55.455C139.087 43.9996 139.087 25.4268 150.542 13.9714C161.998 2.51604 180.571 2.51604 192.026 13.9714C203.481 25.4268 203.481 43.9996 192.026 55.455Z",
    fill: "#F7F9ED"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9757)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 23,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11322_9757",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 23,
    width: 80,
    height: 80
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 63,
    r: 40,
    fill: "#CCCCCC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11322_9757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.572 124.282C215.253 138.601 192.037 138.601 177.718 124.282C163.399 109.963 163.399 86.7467 177.718 72.4274C192.037 58.1082 215.253 58.1082 229.572 72.4274C243.892 86.7467 243.892 109.963 229.572 124.282Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.283 53.5685C285.963 67.8877 262.747 67.8877 248.428 53.5685C234.109 39.2493 234.109 16.0333 248.428 1.71403C262.747 -12.6052 285.963 -12.6052 300.283 1.71403C314.602 16.0333 314.602 39.2493 300.283 53.5685Z",
    fill: "#F7F9ED"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 77,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 93L171.5 97L178.5 89",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 77,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 93L75.5 97L82.5 89",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 77,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 93,
    r: 2,
    fill: "#24284E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 93,
    r: 2,
    fill: "#24284E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 277,
    cy: 93,
    r: 2,
    fill: "#24284E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 128,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 17,
    r: 2,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 136.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 5.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.5,
    cy: 2.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 114.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.5,
    cy: 131.5,
    r: 1.5,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 107.5,
    r: 1.5,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.5,
    cy: 37.5,
    r: 1.5,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194 9.5L203.5 20",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M275 2.5L267.5 17",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9757"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 31,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9757"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 31,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9757"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 23,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceHobbyDevelopment);
export default __webpack_public_path__ + "static/media/persistence-hobby-development.c7c3f069cf08cec5fa59fded02ac1bcd.svg";
export { ForwardRef as ReactComponent };